

export const YEARLY_DISCOUNT = 0.2; // assuming discount is 10%

